import { request } from '../utils/Api';

export function search(
  query = '',
  interests = null,
  district = null,
  suburb = null,
  breed = null,
  needs = null,
  page = 0,
  endpoint = 'home/search',
  sort = null,
  accessToken,
  nearestMe = false,
  maxDegrees = 5,
) {
  // eslint-disable-line
  return dispatch =>
    new Promise((resolve, reject) => {
      request(
        endpoint,
        'POST',
        {
          query,
          interests,
          needs,
          district,
          suburb,
          breed,
          page,
          sort,
          nearestMe,
          maxDegrees,
        },
        {
          Authorization: `Bearer ${accessToken}`,
        },
      ).then(
        response => {
          if (response.status === 200) {
            dispatch({
              type: 'SEARCH_RESULTS',
              payload: response.data,
            });
            dispatch({
              type: 'SAVE_SEARCH',
              payload: {
                query,
                interests,
                needs,
                district,
                suburb,
                breeds: breed,
                page,
                sort,
                nearestMe,
                maxDegrees,
              },
            });

            resolve(response.data);
          } else {
            reject();
          }
        },
        err => {
          reject(err);
        },
      );
    });
}

export function updateSearch(fields) {
  return dispatch =>
    new Promise(resolve => {
      dispatch({
        type: 'UPDATE_SEARCH',
        payload: fields,
      });

      resolve();
    });
}



// WEBPACK FOOTER //
// ./src/actions/search.js